ALLOWED_CONTROLLER = 'm_transactions'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  $from_date = $('#from_date')
  $to_date = $('#to_date')

  table = $('#transactions').dataTable
    sPaginationType: "full_numbers"
    bJQueryUI: true
    bProcessing: true
    bServerSide: true
    iDisplayLength: 50
    sAjaxSource: $('#transactions').data('source')
    order: [ [ 1, "desc" ] ]
    fnServerParams: (aoData) ->
      aoData.push
        name: 'from_date'
        value: $from_date.val()
      aoData.push
        name: 'to_date'
        value: $to_date.val()

  $('*[data-selector="calendar"]').datepicker()

  $('#from_date, #to_date').on 'change', ->
    manage_dates()

  manage_dates = ->
    if check_date_format($from_date.val()) && check_date_format($to_date.val())
      $from_date.val(verify_date($from_date.val()))
      $to_date.val(verify_date($to_date.val()))
      $('#date-warning-text').text('')
      set_export_csv_params()
      table.fnDraw()
    else
      $('#date-warning-text').text('Date must be in format mm/dd/yyyy')

  verify_date = (date_string) ->
    return if date_string == ''

    month = parseInt(/(^\d+)/.exec(date_string)[1])
    day = parseInt(/^\d+\/(\d+)/.exec(date_string)[1])
    year = parseInt(/^\d+\/\d+\/(\d+)/.exec(date_string)[1])
    max_day = new Date(year, month, 0).getDate()

    month = 1 if month < 1
    month = 12 if month > 12
    day = 1 if day < 1
    day = max_day if day > max_day

    output = ''
    output = '0' if month < 10
    output = output + month.toString() + '/'
    output = output + '0' if day < 10
    output = output + day.toString() + '/' + year.toString()
    return output

  check_date_format = (date_string) ->
    regex = /^\d{1,2}\/\d{1,2}\/\d{4}$/
    return regex.test(date_string) || date_string == ''

  export_href = ->
    regex = /(^[^.]*\.csv)/
    url = $('#export_csv').attr('href')
    return regex.exec(url)[0]

  set_export_csv_params = ->
    date_params =
      '?from_date=' + encodeURIComponent($from_date.val()) +
        '&to_date=' + encodeURIComponent($to_date.val())
    $('#export_csv').attr('href', (export_href() + date_params))

$(document).ready(ready)
